import React from 'react';

import IslandPage from './IslandPage.jsx';
import { Mask } from '../dumb_component';

export const MIMain = ({ focusedIsland, check, quit, save, changeData, imgHasChanged}) => {

  console.log('MAIN FOCUSED ISLAND: ', focusedIsland)

  return(
    <div id='result-main' className='result-panel left shadow' style={{ backgroundColor:'white' }}>
      <div className={'result-header left shadow overflow'} style={{ justifyContent: 'center', alignItems: 'center'}}>
        <div>
          <div style={{ flex: 5, justifyContent: 'flex-end'}}>
            {
              focusedIsland.NOM_ILOTS ?
                focusedIsland.NOM_ILOTS.NOM_SHOM ?
                  focusedIsland.NOM_ILOTS.NOM_SHOM : null
                :
                  null
            }
          </div>
          <div className='center'>|</div>
          <div style={{ flex: 5}}>
            Histolitt v2 : {focusedIsland.ID.HISTOLITT_V2}
          </div>
        </div>
        <button 
        onClick={() => check()}
        className={'shadow round-button'} style={{ position: 'absolute', right: 20, fontSize: 20 }}>
          ×
        </button>
      </div>
      <div style={{background: '#eee', position: 'relative'}} className='result-content left overflow'>
        <div id='mi-main-content'>
          {
            focusedIsland ? 
              <IslandPage island={focusedIsland} changeData={(table, field, text) => changeData(table, field, text)} imgHasChanged={imgHasChanged} />
            :
              null
          }
        </div>
        {
          <div className='relative-fixed-mask' id='unsaved-alert' style={{ display: 'none'}}
          onClick={() => {
            document.getElementById('mi-main-content').className = '';
            document.getElementById('unsaved-alert').style.display = 'none'
          }}>
            <div className='relative-mask-panel shadow flex-dir-column' style={{ justifyContent: 'center', alignItems: 'center'}}>
              <p>Sauvegarder les modifications ?</p>
              <div style={{ width: '100%'}}>
                <button
                onClick={() => quit()}
                className='regular-button' style={{width: '50%'}}>Non</button>
                <button
                onClick={() => save(true)}
                className='regular-button' style={{width: '50%'}}>Oui</button>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  )
};